module.exports = __webpack_public_path__ + "static/media/round-1_2.54d59180.jpg";